import DetailScreen from '../components/DetailScreen';
import Settings from './Settings';

// You tab — the existing Settings content under the standard tab-screen header,
// so it gets the shared shell and the bottom tab bar. Settings renders its own
// sticky header and page shell when reached directly at /settings; `embedded`
// suppresses those so DetailScreen supplies them here instead.
export default function YouScreen() {
  return (
    <DetailScreen title="You">
      <Settings embedded />
    </DetailScreen>
  );
}
